angular.module("avant.controllers").controller("LoginModalCtrl", ["$scope", "$modalInstance", "AuthenticationService", "$window", "HeapService", "$timeout", "ConfigService", '$rootScope',
  ($scope, $modalInstance, AuthenticationService, $window, HeapService, $timeout, ConfigService, $rootScope) ->
    HeapService.track "app:relogin_status:started"

    $scope.credentials =
      email: $rootScope?.customer?.email
      password: null
      mfaCode: null
      csrfToken: null
      focus_password: $rootScope?.customer?.email?

    $scope.authenticate = ->
      $scope.signingIn = true
      $scope.error_message = null
      $scope.info_message = null
      AuthenticationService.authenticate($scope.credentials).then((data) ->
        HeapService.track "app:relogin_status:success"
        HeapService.customerAuthenticated true
        $modalInstance.close(data)
      ).catch((err) ->
        $scope.error_message = "Invalid email or password."
        $scope.signingIn = false
        if(err?.data?.mfaRequired)
          $scope.needsMFA = true
          $scope.credentials.csrfToken = err?.data?.csrfToken
        else
          $scope.error_message = if $scope.credentials.mfaCode then 'Invalid Code' else "Invalid email or password."
      )

    $scope.resendMFACode = ->
      $scope.signingIn = true
      $scope.error_message = null
      $scope.info_message = null
      AuthenticationService.resendMFACode($scope.credentials).then((data) ->
        MixpanelService.track "app:relogin_status:resendMFACode"
        HeapService.track "app:relogin_status:resendMFACode"
      ).then(
        $scope.info_message = 'Code resent'
        $scope.error_message = null
        $scope.signingIn = false
      ).catch(->
        $scope.error_message = 'Failed to resend code'
        $scope.info_message = null
        $scope.signingIn = false
      )

    $scope.forgotPassword = ->
      $timeout(->
        $window.location.replace "/password/new?email=#{$scope.credentials.email}"
      , 1000)

    $scope.closeLogoutModal = ->
      $window.location.replace ConfigService.logoutUrl

])
